import React from "react";
import { observer } from "mobx-react";
import SectionSources from "./SectionSources";

const TYPE_META = {
  alumni:           { icon: "🎓", label: "Alumni" },
  shared_employer:  { icon: "🏢", label: "Past Employer" },
  board_role:       { icon: "💼", label: "Board Role" },
  volunteer:        { icon: "🤝", label: "Volunteer" },
  speaking:         { icon: "🎤", label: "Speaking" },
  award:            { icon: "🏆", label: "Award" },
  hobby:            { icon: "🎯", label: "Hobby" },
  community:        { icon: "👥", label: "Community" },
  personal_interest:{ icon: "✨", label: "Interest" },
  // Legacy types — keep so older cached records still render
  person:           { icon: "👤", label: "Person" },
  company:          { icon: "🏢", label: "Company" },
  event:            { icon: "📅", label: "Event" },
  platform:         { icon: "💻", label: "Platform" },
  metric:           { icon: "📊", label: "Metric" },
  other:            { icon: "📌", label: "Other" }
};

const KeyMentions = observer(({ mentions, serpLinks }) => {
  if (!mentions || mentions.length === 0) return null;

  return (
    <div className="drSection">
      <div className="drSectionHeader">
        <span className="drSectionIcon">🔑</span>
        <h3>Personal Hooks</h3>
        <span className="drSectionCount">{mentions.length}</span>
      </div>
      <div className="drMentionsList">
        {mentions.map((m, i) => {
          const meta = TYPE_META[(m.type || "other").toLowerCase()] || TYPE_META.other;
          return (
            <div key={i} className="drMentionCard">
              <div className="drMentionHeader">
                <span className="drMentionIcon" aria-hidden="true">{meta.icon}</span>
                <span className="drMentionTypeChip">{meta.label}</span>
                <span className="drMentionValue">{m.value}</span>
                {m.date && <span className="drMentionDate">{m.date}</span>}
              </div>
              {m.context && (
                <p className="drMentionContext">{m.context}</p>
              )}
              {m.warm_angle && (
                <div className="drMentionWarm">
                  <span className="drMentionWarmLabel">Warm angle</span>
                  <span className="drMentionWarmText">{m.warm_angle}</span>
                </div>
              )}
              {m.link && (
                <a
                  href={m.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="drMentionLink"
                >
                  Source ↗
                </a>
              )}
            </div>
          );
        })}
      </div>

      <SectionSources
        serpLinks={serpLinks}
        labels={["PROSPECT_NEWS_MENTIONS", "PROSPECT_PODCASTS_EVENTS", "PROSPECT_YOUTUBE_TALKS"]}
      />
    </div>
  );
});

export default KeyMentions;
